// FreeSpinReelController.js

import ReelController from "../../../Elements/Reel/ReelController";

class FreeSpinReelController extends ReelController {}

export default FreeSpinReelController;
